<mat-toolbar color="accent">View MOH Forms</mat-toolbar>

<div class="flex min-h-[80vh] flex-col p-2">
  <pr-moh-form-viewer [forms]="forms" />
</div>

<mat-dialog-actions>
  <pt-buttons-container padding="none">
    <button mat-stroked-button mat-dialog-close>Close</button>
  </pt-buttons-container>
</mat-dialog-actions>
